<template>
  <div id="app" data-v-app>
    <van-sticky>
      <van-nav-bar
        style="background-color: #3f78f6"
        title=""
        left-text=""
        left-arrow
        @click-left="onClickLeft"
      >
        <template #title>
          <span style="color: white; font-size: 0.4rem">我的信息</span>
        </template>
        <template #left>
          <van-icon name="arrow-left" color="white" size="18" />
        </template>
      </van-nav-bar>
    </van-sticky>
    <!-- @edit="onEdit"  @select="onSelect" -->
    <section class="van-doc-demo-section">
      <div class="van-doc-demo-block">
        <div
          class="locusItems"
          v-for="item in list"
          :key="item.id"
          @click="test(item.personal_number)"
        >
          <van-radio-group v-model="checked">
            <table border="0" style="font-size: 0.4rem; margin: 0 0.5rem">
              <tr>
                <td rowspan="7">
                  <van-radio :name="item.personal_number" shape="square"> </van-radio>
                </td>
              </tr>
              <tr>
                <td rowspan="7" >
                   <van-image  show-loading  fit="fill"  width="1.5rem"   height="1.5rem"  round    :src="item.imageUrl" />
                </td>
              </tr>
              <tr>
                <td style="text-align: right; color: #666666">学校：</td>
                <td colspan="2">{{ item.ftime }}</td>
              </tr>
              <tr>
                <td style="text-align: right; color: #666666">班级：</td>
                <td colspan="2">{{ item.dep }}</td>
              </tr>
              <tr>
                <td style="text-align: right; color: #666666">姓名：</td>
                <td colspan="2">{{ item.name }}</td>
              </tr>
              <tr>
                <td style="text-align: right; color: #666666">学号：</td>
                <td colspan="2">{{ item.personal_number }}</td>
              </tr>
              <tr>
                <td style="text-align: right; color: #666666">手机号：</td>
                <td>{{ item.tel }}</td>
              </tr>
            </table>
          </van-radio-group>
        </div>
      </div>
    </section>
    <van-tabbar fixed>
      <van-tabbar-item
        :to="{
          path: 'StudentAdd',
          query: {
            student: this.student,
            xiaoqu: this.xiaoqu,
            page: this.page,
          },
        }"
      >
        添加学生</van-tabbar-item
      >
      <van-tabbar-item @click="UserImage"> 照片上传</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chosenContactId: "1",
      list: [],
      checked: "",
      student: "",
      page: "",
      xiaoqu: "",
    };
  },
  created() {
    this.student = this.$route.query.student;
    this.page = this.$route.query.page;
    this.xiaoqu = this.$route.query.xiaoqu;
    console.log(
      "传递过来得学生ID：" + this.student + "和默认轮播定位：" + this.page
    );
    this.onload();
  },
  methods: {
    onload(){
       var json = window.localStorage.getItem("User");
    var jsonObj = JSON.parse(json);
    console.log("身份:" + jsonObj[0]["shenfen"]);
    var code;
    if (jsonObj[0]["shenfen"] == "学生") {
      code = jsonObj[0]["number"];
    } else if (jsonObj[0]["shenfen"] == "家长") {
      code = jsonObj[0]["phone"];
    } 
    var params_json = {
      userid: code,
      action: "parentStudentList",
      param1: "",
      param2: "",
      param3: "",
      param4: "",
      param5: "",
    };
      let  _this = this;
    this.$http.post("/web/list", params_json).then(function (res) {
      // let obj = res.data["rows"];
      console.log(res.data["rows"]);
      _this.list = res.data["rows"];
      for (var i in _this.list) {
        if(window.localStorage.getItem( _this.list[i]["personal_number"] )== "" ||window.localStorage.getItem( _this.list[i]["personal_number"])== "undefined" || window.localStorage.getItem(  _this.list[i]["personal_number"])==  null || window.localStorage.getItem(  _this.list[i]["personal_number"]) == "null")
        {
           _this.imageurl = require('@/image/hread.png');
        }
        else
        {
               _this.imageurl =window.localStorage.getItem(  _this.list[i]["personal_number"] ); 
        }
        _this.list[i]['imageUrl'] = _this.imageurl;
          }
    });
    },
    test(id) {
      console.log("电击复选框："+id);
      this.checked = id;
      return this.checked;
    },
    onClickLeft() {
      this.$router.push({
        path: "Index",
        query: {
          page: this.page,
        },
      });
    },
    UserImage() {
      if (this.checked == "" || this.checked == null) {
        this.$notify({
          type: "danger",
          message: "请选择一条信息进行操作.",
        });
        return;
      }
      this.$router.push({
        path: "UserInfo",
        query: {
          student: this.checked,
          page: this.page,
          xiaoqu: this.xiaoqu,
        },
      });
    },
    onEdit(contact) {
      this.$toast("编辑" + contact.id);
    },
    onSelect(contact) {
      this.$toast("选择" + contact.id);
    },
  },
};
</script>

<style>
</style>